import styled from 'styled-components';
import { TooltipStyled } from '../TooltipStyled';
import { rem } from 'polished';

export const TooltipStyledAC = styled(TooltipStyled)`
    .tooltip-box {
        font-size: ${rem('13px')} !important;
        width: fit-content !important;
        padding: ${rem('7px')} ${rem('10px')} !important;
    }
`;
